import { use } from "react";
import ContextoAutenticacaoJwt from "./ContextoAutenticacaoJwt";

function useAutenticacaoJwt() {
	const contexto = use(ContextoAutenticacaoJwt);

	if (contexto === undefined)
		throw new Error("ContextoAutenticacaoJwt precisa ser usado dentro de ProvedorAutenticacaoJwt");

	return contexto;
}

export default useAutenticacaoJwt;
